import LegalLayout from "./LegalLayout";
import { MessageCircle, Mail, Clock } from "lucide-react";

export default function ContactPage() {
  const WHATSAPP_NUMBER = "919662518986";

  return (
    <LegalLayout title="Get in Touch">
      <p>
        Have a question about the Masterclass, registration, or VEE Consultancy? We'd love to hear from you.
      </p>

      <div className="not-prose grid md:grid-cols-2 gap-5 my-10">
        <a
          href="mailto:consultancyvee@gmail.com?subject=Query%20for%20VEE%20Consultancy"
          className="group rounded-2xl border border-slate-800 bg-slate-900/40 p-6 hover:border-emerald-500 transition-all hover:-translate-y-0.5"
          data-testid="contact-email"
        >
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center mb-4 shadow-[0_6px_20px_rgba(16,185,129,0.3)]">
            <Mail className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-display text-lg text-white mb-1">Email</h3>
          <p className="text-sm text-slate-400 mb-2">Send us your query anytime.</p>
          <p className="font-mono text-sm text-emerald-400 group-hover:underline break-all">consultancyvee@gmail.com</p>
        </a>

        <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mb-4 shadow-[0_6px_20px_rgba(251,191,36,0.3)]">
            <Clock className="w-5 h-5 text-white" />
          </div>
          <h3 className="font-display text-lg text-white mb-1">Response Time</h3>
          <p className="text-sm text-slate-400 mb-2">Monday to Saturday</p>
          <p className="font-mono text-sm text-amber-400">10:00 AM – 7:00 PM IST</p>
        </div>
      </div>

      <h2 className="text-2xl font-bold mt-10 mb-3">Before Reaching Out</h2>
      <p>Most common questions are already answered on our landing page:</p>
      <ul className="list-disc pl-6 space-y-2">
        <li>Is the webinar free? — <strong>Yes, 100% free.</strong></li>
        <li>Duration? — <strong>75 minutes</strong> (50 min content + 25 min live Q&A).</li>
        <li>Can beginners join? — <strong>Yes.</strong></li>
        <li>Are you SEBI-registered? — <strong>No.</strong> We provide education only. See <a href="/what-we-provide">What We Provide</a>.</li>
      </ul>
    </LegalLayout>
  );
}
